// capitalize first letter of a word
// i/p:  abc
// o/p:  Abc

const capitalizeFirstLetter = (inputString: string): string =>
  inputString.charAt(0).toUpperCase() + inputString.slice(1);

// capitalize first letter of each word in an array
// i/p:  ['abc','cdf']
// o/p:  ['Abc','Cdf']

const capitalizeWords = (arr: string[]) =>
  arr.map((word) => {
    const capitalizedFirst = word?.charAt(0)?.toUpperCase();
    const rest = word.slice(1).toLowerCase();
    return capitalizedFirst + rest;
  });

const capitalizeString = (inputString: string): string =>
  inputString.toUpperCase();

// i/p: 1234543121
// o/p: xxxxxx3121
const maskSensitiveData = (data: string) => {
  // Replace all characters except the last four with 'X'
  const lastFour = data.slice(-4);
  const maskedString = data.slice(0, -4).replace(/\d/g, 'x');
  return maskedString + lastFour;
};

const snakeToCamel = (snakeString: string) =>
  (snakeString?.toLowerCase() || '')
    .split('_')
    .map(
      (word: string, index: number) =>
        index === 0
          ? word // Keep the first word lowercase
          : word.charAt(0).toUpperCase() + word.slice(1) // Capitalize subsequent words
    )
    .join('');

const SNAKE_CASE_TOKEN_PATTERN = /[a-z][a-z0-9]*(?:_[a-z][a-z0-9]*)+/gi;

const snakeCaseToTitleCase = (value: string): string =>
  capitalizeWords((value?.toLowerCase() || '').split('_')).join(' ');

const formatSnakeCaseInMessage = (message: string): string =>
  message.replace(SNAKE_CASE_TOKEN_PATTERN, (match) =>
    snakeCaseToTitleCase(match)
  );

const pluralize = (count: number, singular: string, plural?: string) =>
  count === 1 ? singular : plural ?? `${singular}s`;

const arrayToCommaSeparatedString = (array: Array<string>) => {
  if (!Array.isArray(array) || array.length === 0) {
    return '';
  }
  return array.join(',');
};

export {
  arrayToCommaSeparatedString,
  capitalizeFirstLetter,
  capitalizeString,
  capitalizeWords,
  formatSnakeCaseInMessage,
  maskSensitiveData,
  pluralize,
  snakeCaseToTitleCase,
  snakeToCamel
};

export const convertKeyToText = (key: string) => {
  const text = key.replace(/([A-Z])/g, ' $1').trim();
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};
